import React, { useState } from "react";
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
    TextField,
    InputAdornment
} from "@mui/material";
import KenSelect from "../../../../../../GlobalComponents/KenSelect";
import { DatePicker } from "@mui/x-date-pickers";
import { DROP_DOWN, QuizConfig } from "../Helper/AssessmentHelper";
interface ILayout {
    assessmentData: QuizConfig;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RestrictAccess = ({ assessmentData, handleChange }: ILayout) => {
    const [restrictionType, setRestrictionType] = useState("from");

    return (
        <Box sx={{ backgroundColor: "#f8f9fa", padding: 3, borderRadius: 2, textAlign: "start" }}>
            <Typography variant="subtitle1" fontWeight={600}>
                Fill the details you want to add a restriction
            </Typography>

            {/* First Row: Radio buttons & Date Picker */}
            <Grid container spacing={3} sx={{ mt: 2 }} alignItems="center">
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">Select restriction date</Typography>
                    <FormControl component="fieldset">
                        <RadioGroup row value={restrictionType} onChange={(e) => setRestrictionType(e.target.value)}>
                            <FormControlLabel value="from" control={<Radio color="primary" />} label="From" />
                            <FormControlLabel value="until" control={<Radio color="primary" />} label="Until" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <DatePicker sx={{background:"#ffffff"}} slotProps={{ textField: { fullWidth: true, placeholder: "Select" } }} />
                </Grid>
            </Grid>

            {/* Second Row: Grade, Must be >, Must be < */}
            <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">Grade</Typography>
                     <KenSelect
                                                              fullWidth
                                                              name="grade"
                                                              value={assessmentData.grade}
                                                              onChange={handleChange}
                                                              options={DROP_DOWN.Grade}
                                                              sx={{ height: '3rem', marginTop: 1 }}
                                                          />
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">Must be &gt;</Typography>
                    <TextField
                        placeholder="Enter"
                        sx={{ background: "#ffffff" }}
                        fullWidth
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">Must be &lt;</Typography>
                    <TextField
                        placeholder="Enter"
                        sx={{ background: "#ffffff" }}
                        fullWidth
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default RestrictAccess;
